export const CATEGORY_ICONS = {
  electricite: "Zap",
  eau: "Droplets",
  ascenseur: "MoveVertical",
  gardiennage: "Shield",
  nettoyage: "Sparkles",
  jardinage: "Trees",
  reparations: "Wrench",
  assurance: "FileCheck2",
  syndic: "Briefcase",
  autres: "Package",
};

export const CATEGORY_COLORS = {
  electricite: "#F59E0B",
  eau: "#3254C6",
  ascenseur: "#0A4D3C",
  gardiennage: "#6366F1",
  nettoyage: "#06B6D4",
  jardinage: "#10B981",
  reparations: "#C05A46",
  assurance: "#8B5CF6",
  syndic: "#64748B",
  autres: "#94A3B8",
};

export const money = (n) =>
  (Number(n) || 0).toLocaleString("fr-FR", { maximumFractionDigits: 0 });

export const fmtDate = (d, lang = "fr") => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString(lang === "ar" ? "ar-MA" : "fr-FR", {
      day: "numeric", month: "short", year: "numeric",
    });
  } catch { return d; }
};

export const initials = (name = "") =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const avatarColor = (name = "") => {
  const colors = ["#0A4D3C", "#3254C6", "#C05A46", "#8B5CF6", "#0891B2", "#B45309"];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return colors[Math.abs(h) % colors.length];
};
